import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer id="main-footer" className="page-section">
      <Container className="text-center">
        <span id="copyright">
          &copy; Noches De Salsa {year}. Site by{" "}
          <a href="http://www.christiancoda.com">Christian Coda</a>
        </span>
      </Container>
    </footer>
  );
};

export default Footer;
